import { useInfiniteQuery } from '@tanstack/react-query';
import { ICompanyAggregateActivity, ImpersonationBroker, IPagedCollection } from '../../extViewmodels';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'reports/company';

export function useReportsCompanyQuery({
	enabled,
	endDate,
	startDate,
	userId,
	pageSize = 25,
}: {
	enabled?: boolean;
	endDate: Date;
	startDate: Date;
	userId?: string;
	pageSize?: number;
}) {
	const userSession = useUserSession();
	return useInfiniteQuery({
		enabled,
		queryKey: [BASE_QUERY_KEY, endDate, startDate, userId, pageSize],
		queryFn: ({ pageParam }) => {
			return userSession.webServiceHelper.callAsync<IPagedCollection<ICompanyAggregateActivity>>(
				ImpersonationBroker.composeApiUrl({
					urlPath: `reports/company`,
					queryParams: {
						pageSize,
						pageToken: pageParam,
					},
				}),
				'POST',
				{ endDate, startDate, userId }
			);
		},
		getNextPageParam: lastPage => lastPage.pageToken,
		initialPageParam: '',
	});
}
